export default "__VITE_ASSET__CzeztuQs__"